// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__up6Jg","item":"PaymentsMobile_item__78fZL","label":"PaymentsMobile_label__3dzJK","amount":"PaymentsMobile_amount__2KGMt"};